import React from "react";
import {
  PlxsText,
  PlxsChip,
  PlxsHeading,
  PlxsCallout,
} from "@plexlogic/plexus-ui";

interface WizardStepHeaderProps {
  title: string;
  description?: string;
  marginBottom?: string;
  badgeLabel?: string;
  badgeTone?: "positive" | "neutral" | "caution" | "brand";
  callout?: {
    message: string;
    supportingCopy?: string;
    tone?: "positive" | "neutral" | "caution" | "brand";
    dataTestId?: string;
  };
}

const WizardStepHeader: React.FC<WizardStepHeaderProps> = ({
  title,
  description,
  marginBottom = "2rem",
  badgeLabel,
  badgeTone = "brand",
  callout,
}) => {
  return (
    <div style={{ marginBottom }}>
      {/* Header Section with Title and Badge */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: description ? "var(--plexus-space-sm, 8px)" : callout ? "var(--plexus-space-md, 16px)" : "0",
          flexWrap: "wrap",
          gap: "var(--plexus-space-sm, 8px)",
        }}
      >
        <PlxsHeading element="h3">
          {title}
        </PlxsHeading>
        {badgeLabel && <PlxsChip label={badgeLabel} tone={badgeTone} />}
      </div>

      {/* Body Section - Description */}
      {description && (
        <div style={{ marginBottom: callout ? "var(--plexus-space-md, 16px)" : "0", fontSize: '13px' }}>
          <PlxsText size="sm">
            {description}
          </PlxsText>
        </div>
      )}

      {/* CallOut Section */}
      {callout && (
        <PlxsCallout
          message={callout.message}
          supportingCopy={callout.supportingCopy}
          tone={callout.tone || "brand"}
          dataTestId={callout.dataTestId || "wizard-step-callout"}
        />
      )}
    </div>
  );
};

export default WizardStepHeader;
